module.exports = __webpack_public_path__ + "img/Ingenierito-transformer-volteado-1.441be56e.webp";